const salaries = {
  permissionSource: 'api::salary.salary',
  creationTitle: 'Create Salary',
  creationEndPoint: '/salaries',
  detailTitle: 'Salary: :code',
  detailEndPoint: '/salaries/:id?populate=*',
  detail: [
    {
      label: 'Code',
      value: 'code',
      tag: 'input',
      type: 'text',
      placeholder: 'Salary Code',
      required: true,
    },
    {
      label: 'Payroll Date',
      value: 'payroll_date',
      tag: 'date-picker',
      required: true,
    },
    {
      label: 'Amount',
      value: 'amount',
      tag: 'input',
      type: 'number',
      required: true,
    },
    {
      label: 'Staff',
      value: 'staff',
      tag: 'single-select',
      dataSourceUrl: '/staffs',
      dataLabel: 'name',
      required: true,
    },
    {
      label: 'Status',
      value: 'status',
      tag: 'single-enum-select',
      dataSourceUrl: '/content-type-builder/content-types/api::salary.salary',
      dataLabel: 'status',
      required: true,
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
}
export default salaries
